var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('newsbanner'),_vm._v(" "),_c('div',{staticClass:"row body-width divcss5"},[_c(_vm.currenttable,{ref:"cargoholdall",tag:"component"}),_vm._v(" "),_c('upanddown',{attrs:{"id":_vm.id,"maxid":_vm.maxid,"up":_vm.up,"down":_vm.down,"updown":_vm.updown,"downnew":_vm.downnew}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bb5f2654","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/contentcoms/newscontentcoms/Oldnewscontent.vue
// module id = null
// module chunks = 